import { ChangeDetectionStrategy, Component, Signal, computed, inject, input } from '@angular/core';

import { CorrectScoreHeaderButtonTabs, EventModel, EventOptionGroup, Tv2MarketParameters } from '@frontend/sports/betting-offer/feature/model';
import { PeriodType } from '@frontend/sports/betting-offer/feature/types';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';

import { CorrectScoreOptionGroupCompactComponent } from './correct-score-option-group-compact.component';
import { CorrectScoreOptionGroupToggleViewService } from './correct-score-option-group-toggle-view.service';
import { CorrectScoreOptionGroupComponent } from './correct-score-option-group.component';

@Component({
    selector: 'ms-correct-score-option-group-wrapper',
    templateUrl: './correct-score-option-group-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CorrectScoreOptionGroupComponent, CorrectScoreOptionGroupCompactComponent],
})
export class CorrectScoreOptionGroupWrapperComponent {
    private correctScoreOptionGroupToggleViewService = inject(CorrectScoreOptionGroupToggleViewService);

    event = input.required<EventModel>();
    tracking = input.required<string>();
    trackingModuleType = input('');
    optionGroup = input.required<EventOptionGroup>();
    isShowMoreDisabled = input.required<boolean>();
    showMarketHelp = input.required<boolean>();
    crmPromotedOptionIdsMap = input<StringDictionary<number>>({});
    eventHelpText = input<string | undefined>(undefined);
    sourceOfPick = input(SourceOfPick.Other);
    betDetails = input('');
    optionsLimitOverride = input<number | undefined>(undefined);

    private _showRegularTemplate: Signal<boolean> = computed(() => {
        const periodType = this.optionGroup().parameters?.find((p) => p.key === Tv2MarketParameters.Period)?.value as PeriodType;
        return periodType !== PeriodType.RegularTime;
    });

    showRegularTemplate: Signal<boolean> = computed(() => {
        return (
            this._showRegularTemplate() ||
            this.correctScoreOptionGroupToggleViewService.currentViewId() === CorrectScoreHeaderButtonTabs.CorrectScoreRegularView
        );
    });
}
